import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { collection, collectionData, CollectionReference, deleteDoc, doc, setDoc, Timestamp } from '@angular/fire/firestore';
import { FireStoreCollection } from '@shared/models/firestore';
import { FirestoreService } from '@shared/services/firestore/firestore.service';
import { IUserDevice } from '@user/models/user-device';

@Injectable({
	providedIn: 'root',
})
export class UserDeviceService extends FirestoreService<IUserDevice> {
	constructor() {
		super(FireStoreCollection.USERS);
	}

	private devicesCollection(userId: string): CollectionReference<IUserDevice> {
		return collection(this.firestore, `${FireStoreCollection.USERS}/${userId}/devices`) as CollectionReference<IUserDevice>;
	}

	async addOrUpdateDevice(userId: string, deviceId: string, device: IUserDevice): Promise<void> {
		const deviceRef = doc(this.firestore, `${FireStoreCollection.USERS}/${userId}/devices/${deviceId}`);
		await setDoc(
			deviceRef,
			{
				...device,
				updatedAt: Timestamp.now(),
				createdAt: device.createdAt || Timestamp.now(),
			},
			{ merge: true },
		);
	}

	async removeDevice(userId: string, deviceId: string): Promise<void> {
		const deviceRef = doc(this.firestore, `${FireStoreCollection.USERS}/${userId}/devices/${deviceId}`);
		await deleteDoc(deviceRef);
	}

	listDevices(userId: string): Observable<Array<IUserDevice>> {
		const devicesCol = this.devicesCollection(userId);
		return collectionData<IUserDevice>(devicesCol, { idField: 'id' });
	}
}
